import { useCallback, useState } from 'react';
import { ApiError } from '@vanialabs/core-api';

import {
  updateTenantDomain,
} from '../api/tenant-domains.api';
import type {
  TenantDomain,
  UpdateTenantDomainStateInput,
} from '../types/tenant-domain.types';

function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const detail = (error.body as { detail?: unknown } | undefined)?.detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
  }
  return 'خطا در به‌روزرسانی دامنه تننت. لطفاً دوباره تلاش کنید.';
}

export function useUpdateTenantDomain(tenantId: number | string) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = useCallback(async (
    domainId: number | string,
    input: UpdateTenantDomainStateInput,
  ): Promise<TenantDomain> => {
    setSubmitting(true);
    setError(null);

    try {
      return await updateTenantDomain(tenantId, domainId, input);
    } catch (requestError) {
      setError(errorMessage(requestError));
      throw requestError;
    } finally {
      setSubmitting(false);
    }
  }, [tenantId]);

  const resetError = useCallback(() => setError(null), []);

  return { submit, submitting, error, resetError };
}
